import axios from 'axios';


//Function that calls the geoserver table councillor in order to get the information for the councillors of the selected ward. The ward has been selected from the list of addresses given by the postcode API call. 
const GetCouncillor = () => {

  //TODO: remove the hard-coded version!!! It is only here because we are using the test proxy
  let selectedWard = document.querySelector('#selectedAddress').value;
  // console.log('Selected Ward',selectedWard)
  //let selectedWard = 'Hackney Central';


  axios.get(`${process.env.GEOSERVER_URL}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=government:councillor&propertyName=councillor1_name,councillor1_party,councillor1_contact,councillor2_name,councillor2_party,councillor2_contact,councillor3_name,councillor3_party,councillor3_contact&cql_filter=ward_name='${selectedWard}'`, {
  })
    .then((res) => {
      // console.log(res.data)
      let councillor1_name = res.data.features[0].properties.councillor1_name;
      let councillor2_name = res.data.features[0].properties.councillor2_name;
      let councillor3_name = res.data.features[0].properties.councillor3_name;
      let councillor1_contact = res.data.features[0].properties.councillor1_contact;
      let councillor2_contact = res.data.features[0].properties.councillor2_contact;
      let councillor3_contact = res.data.features[0].properties.councillor3_contact;
      let councillor1_party = res.data.features[0].properties.councillor1_party;
      let councillor2_party = res.data.features[0].properties.councillor2_party;
      let councillor3_party = res.data.features[0].properties.councillor3_party;

      document.querySelector('code').innerHTML = "<label class='govuk-label  lbh-label' for='councillor_table'>Councillors for the ward of <em>" + selectedWard + "</em>: </label>";

      if (councillor3_name) {
        if (councillor3_name == "Vacant seat"){
          document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table' id='councillor_table'> <tbody class='govuk-table__body'>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</a></td>"
          + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'><a href='mailto:"+ (councillor1_contact) + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>"
          + "<td class='govuk-table__cell'><a href='mailto:"+ (councillor2_contact) + "'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'>" + councillor3_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor3_party || "&nbsp &nbsp") + "</td>"
          + "<td class='govuk-table__cell'></td>"
          + "</tr></tbody></table>";
        } else {
          document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table' id='councillor_table'> <tbody class='govuk-table__body'>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</a></td>"
          + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'><a href='mailto:"+ (councillor1_contact) + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>"
          + "<td class='govuk-table__cell'><a href='mailto:"+ (councillor2_contact) + "'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor3_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor3_party || "&nbsp &nbsp") + "</td>"
          + "<td class='govuk-table__cell'><a href='mailto:"+ (councillor3_contact) + "'>" +  (councillor3_contact || "&nbsp &nbsp") + "</td>"
          + "</tr></tbody></table>";

        }
       
      }
      else {
        if (councillor1_name == "Vacant seat"){
          document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table'> <tbody class='govuk-table__body'>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'>" + councillor1_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'></td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'><a href='mailto:"+ (councillor2_contact) +"'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>"
          + "</tr></tbody></table>";
        } else if (councillor2_name == "Vacant seat"){
          console.log(councillor2_name);
          document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table'> <tbody class='govuk-table__body'>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'><a href='mailto:"+ (councillor1_contact) + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'>" + councillor2_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'></td>"
          + "</tr></tbody></table>";

        } else {
          document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table'> <tbody class='govuk-table__body'>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'><a href='mailto:"+ (councillor1_contact) + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>"
          + "</tr>"
          + "<tr class='govuk-table__row'>"
          + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>"
          + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>"
          +"<td class='govuk-table__cell'><a href='mailto:"+ (councillor2_contact) +"'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>"
          + "</tr></tbody></table>";
        }
        
      }



      //Catch error of the second axios call - councillor table (Geoserver)
    })
    .catch((error) => {
      console.log('error geoserver!!!');
      document.getElementById("error_message").innerHTML = 'Sorry, there was a problem retrieving councillors for this address. <br>Please note that this service is only available for Hackney addresses.';
      console.error(error);
    })
}

const GetAddressesViaProxy = async() => {
  //type="search"  
  //empty error message and previous lists
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML = 'Loading addresses...';
  document.querySelector('code').innerHTML = '';

  let postcode = document.getElementById("postcode").value;
  let ward = null;
  let results = null;
  let full_address = null;
  //empty former councillors list
  document.querySelector('code').innerHTML = '';

  //First call to get the list of addresses from a postcode
   const res = await fetch(`${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&postcode=${postcode}`);
  //  const res = await fetch(`${process.env.ADDRESSES_API_PROXY_STAGING}?format=detailed&postcode=${postcode}`);

  const response = await res.json();
  //console.log(response.data.data);
  //document.querySelector("code").innerHTML = JSON.stringify(response);


  // Add error message is the postcode is not correct
  if (response.error) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
    // if (!error.isValid) {
    //   console.log(error.response.data.error.validationErrors[0].message);
    //   document.getElementById("error_message").innerHTML = error.response.data.error.validationErrors[0].message;
    // }
    document.getElementById("error_message").innerHTML = "Sorry, an error occured while retrieving addresses";
    document.getElementById("addresses").innerHTML = '';
  }
  //there is a response but the status is not 200
  else if (response.data.statusCode != 200){
    if (! response.data.error.isValid){
      document.getElementById("error_message").innerHTML = "Please enter a valid postcode";
      document.getElementById("addresses").innerHTML = '';
    }
    else {
      document.getElementById("error_message").innerHTML = response.data.error;
      document.getElementById("addresses").innerHTML = '';
    }
  }
  //no error message in the response
  else {
    results = response.data.data.address;
    let pageCount = response.data.data.page_count;
    // console.log(results)

    if (results.length === 0) {
      document.getElementById("error_message").innerHTML = "No address found at this postcode";
      //console.log('empty results');
    }
    else {
     
      document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'>"
        //  + "<label class='govuk-label  lbh-label' for='select-1'> Select your address from the list </label>"
        + "<select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress' >";

      document.getElementById("selectedAddress").innerHTML += "<option disabled selected value> Select your address from the list </option>";
      results.forEach(element => {

        //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
        full_address = [element.line1, element.line2, element.line3, element.line4].filter(Boolean).join(", ");
        ward = element.ward;
        
        //remove simple quotes and special characters
        ward = ward.replace("'", "");
        ward = ward.replace('&', 'and');

        document.getElementById("selectedAddress").innerHTML += "<option value='" + ward + "'>" + full_address + "</option>";
        // console.log(document.getElementById("selectedAddress"))
      });
      //load more pages of resukts if needed -
      
      if (pageCount > 1) {
        for (pgindex = 2 ; pgindex<=pageCount ; ++pgindex){
          loadAddressAPIPageViaProxy(postcode, pgindex);
        }
        //console.log('I need to fetch more!');
      }
      //close list
      document.getElementById("addresses").innerHTML += "</select></div>";
      document.getElementById("selectedAddress").addEventListener('change',GetCouncillor)
    }
  }
};
//List the addresses from the postcode calling the Addresses API. The addresses are printed as a drop down list where you can select. The ward of the selected one is used to called the function GetCouncillor()
const GetAddressesWithoutProxy = () => {
  //empty error message and previous lists
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML = '';
  document.querySelector('code').innerHTML = '';

  let postcode = document.getElementById("postcode").value;
  let ward = null;
  let results = null;
  let full_address = null;
  //empty former councillors list
  document.querySelector('code').innerHTML = '';
  //First call to get the list of addresses from a postcode
  axios.get(`${process.env.ADDRESSES_API_URL}?format=detailed&postcode=${postcode}`, {
    headers: {
      Authorization: process.env.ADDRESSES_API_KEY,
    }
  })
    .then((res) => {
      results = (res.data.data.address);
      let pageCount = res.data.data.page_count;
      //console.log(results)
      if (results.length === 0) {
        document.getElementById("error_message").innerHTML = "No address found at this postcode";
        //console.log('empty results');
      }
      else {
        // document.getElementById("addresses").innerHTML +="<div class='govuk-form-group lbh-form-group'> <label class='govuk-label  lbh-label' for='sselectedAddress'>  Select your address from the list </label>";
        // document.getElementById("addresses").innerHTML +="<select class='govuk-select  lbh-select' id='selectedAddress' name='selectedAddress' onchange='GetCouncillor()'>";

        document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'>"
          //  + "<label class='govuk-label  lbh-label' for='select-1'> Select your address from the list </label>"
          + "<select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress'>";

        document.getElementById("selectedAddress").innerHTML += "<option disabled selected value> Select your address from the list </option>";
        results.forEach(addressLine => {
          //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
          full_address = [addressLine.line1, addressLine.line2, addressLine.line3, addressLine.line4].filter(Boolean).join(", ");
          ward = addressLine.ward;

          //remove simple quotes and special characters
          ward = ward.replace("'", "");
          ward = ward.replace('&', 'and');

          document.getElementById("selectedAddress").innerHTML += "<option value='" + ward + "'>" + full_address + "</option>";
        })
        //load more pages of resukts if needed
        if (pageCount > 1) {
          for (pgindex = 2; pgindex <= pageCount; ++pgindex) {
            loadAddressAPIPage(postcode, pgindex);
          }
        }
        //close list
        document.getElementById("addresses").innerHTML += "</select></div>";
        document.getElementById("selectedAddress").addEventListener('change',GetCouncillor)
      }
    })
    //Catch error of the fist axios call - addresses API
    .catch((error) => {

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (!error.isValid) {
          console.log(error.response.data.error.validationErrors[0].message);
          document.getElementById("error_message").innerHTML = error.response.data.error.validationErrors[0].message;
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);

    })
};



let postcode = document.getElementById('postcode');
let searchBtn = document.getElementById('search');

postcode.addEventListener('keyup', (e) => {
  if (e.key == 'Enter'){
    GetAddressesViaProxy();
    //GetAddressesWithoutProxy();
  }
});
searchBtn.addEventListener('click', (e) => {
    GetAddressesViaProxy();
    //GetAddressesWithoutProxy();
});



//listener for the clear x in the input
postcode.addEventListener("search", (e) => {
  document.getElementById("error_message").innerHTML = "";
  document.getElementById("addresses").innerHTML = '';
  document.querySelector('code').innerHTML = '';
});


//function to add one page of results to the options list

const loadAddressAPIPage = (postcode, pg) => {
  axios.get(`${process.env.ADDRESSES_API_URL}?format=detailed&postcode=${postcode}'&page=${pg}`, {
    headers: {
      Authorization: process.env.ADDRESSES_API_KEY,
    }
  })
    .then((res) => {
      //console.log('page ' + pg + ' = ' + res);
      results = (res.data.data.address);
      for (index = 0; index < addresses.length; ++index) {
        
        //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
        full_address = [results[index].line1, results[index].line2, results[index].line3, results[index].line4].filter(Boolean).join(", ");
        ward = results[index].ward;

        //remove simple quotes and special characters
        ward = ward.replace("'", "");
        ward = ward.replace('&', 'and');

        document.getElementById("selectedAddress").innerHTML += "<option value='" + ward + "'>" + full_address + "</option>";
      }
    })
    .catch((error) => {
      //there shouldn't be anything as the request already returned sth correct for the first page of results
      console.log(error.config);
    })
};


const loadAddressAPIPageViaProxy = async(postcode, pg) => {
  const res = await fetch(`${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&postcode=${postcode}&page=${pg}`);
  // const res = await fetch(`${process.env.ADDRESSES_API_PROXY_STAGING}?format=detailed&postcode=${postcode}&page=${pg}`);
  const response = await res.json();
  
  results = (response.data.data.address);
  //console.log(results);
  for (index = 0; index < results.length; ++index) {
    
    //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
    full_address = [results[index].line1, results[index].line2, results[index].line3, results[index].line4].filter(Boolean).join(", ");
    ward = results[index].ward;

    //remove simple quotes and special characters
    ward = ward.replace("'", "");
    ward = ward.replace('&', 'and');

    document.getElementById("selectedAddress").innerHTML += "<option value='" + ward + "'>" + full_address + "</option>";
  }
};






